import React from 'react';
import { motion } from 'framer-motion';
export function AgitationSection() {
  return <section className="bg-white py-20 px-4 relative" data-id="element-18">
      <div className="max-w-3xl mx-auto" data-id="element-19">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-navy text-center mb-12" data-id="element-20">
          Lo que nadie te dice sobre las noches sin dormir
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="prose prose-lg prose-navy mx-auto space-y-6 text-navy/80 text-lg" data-id="element-21">
          <p data-id="element-22">El agotamiento crónico no es solo cansancio.</p>
          <p data-id="element-23">Es irritabilidad constante que te hace sentir culpable después.</p>
          <p data-id="element-24">
            Es no poder disfrutar los momentos buenos porque estás pensando en
            cuándo va a ser la próxima siesta.
          </p>
          <p data-id="element-25">Es sentirte sola en algo que se supone que debería ser hermoso.</p>
          <p data-id="element-26">
            Es discutir con tu pareja por pequeñeces que en otro contexto no
            importarían nada.
          </p>
          <p data-id="element-27">
            Es perder la paciencia con tu bebé y después no poder perdonarte.
          </p>

          <div className="h-px w-24 bg-sky/30 mx-auto my-8" data-id="element-28"></div>

          <p className="font-semibold text-navy text-xl" data-id="element-29">
            Y lo más difícil de todo es que tu bebé tampoco descansa bien.
          </p>

          <p data-id="element-30">
            Un bebé que no duerme profundo tiene menos horas de sueño reparador.
          </p>
          <p data-id="element-31">
            Y el sueño reparador es exactamente cuando el cerebro consolida el
            aprendizaje, procesa las emociones del día y crece.
          </p>

          <div className="bg-warm-white p-6 rounded-xl border-l-4 border-gold my-8" data-id="element-32">
            <p className="font-bold text-navy mb-2" data-id="element-33">
              El sueño no es un lujo ni para vos ni para tu bebé.
            </p>
            <p data-id="element-34">
              Es una necesidad biológica que cuando no se cubre, tiene
              consecuencias reales.
            </p>
          </div>

          <div className="text-center mt-12" data-id="element-35">
            <p className="text-2xl font-bold text-navy mb-4" data-id="element-36">
              La buena noticia es que esto tiene solución.
            </p>
            <p className="text-xl text-sky font-semibold" data-id="element-37">
              Y la solución es más simple de lo que pensás cuando tenés la
              información correcta.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}